<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M29.333 15.998c0-7.363-5.97-13.331-13.334-13.331-7.363 0-13.333 5.968-13.333 13.33 0 6.654 4.876 12.17 11.25 13.17V19.85h-3.385v-3.853h3.385V13.06c0-3.34 1.99-5.186 5.036-5.186 1.46 0 2.985.26 2.985.26v3.281h-1.681c-1.657 0-2.173 1.028-2.173 2.082v2.5h3.698l-.591 3.854h-3.107v9.316c6.374-1 11.25-6.516 11.25-13.17z"/><path d="M21.247 19.836l.596-3.862h-3.729v-2.506c0-1.056.521-2.086 2.19-2.086H22V8.094s-1.538-.26-3.01-.26c-3.07 0-5.077 1.849-5.077 5.197v2.943H10.5v3.862h3.413v9.335a13.63 13.63 0 004.201 0v-9.335h3.133z"/></svg>
</template>

<script>
export default {
  name: 'brandFacebookFilled'
}
</script>
